import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AutenticacionService } from 'src/app/compartido/autenticacion/autenticacion.service';
import { NotificacionesService } from '../../../compartido/servicios/notificaciones.service';
import { RolUsuario } from 'src/app/compartido/autorizacion/autorizacion.models';
import { Router } from '@angular/router';
import { Notificacion } from './utilidades/notificacion.class';
import { UsuarioDTO } from 'src/app/compartido/autenticacion/autenticacion.models';
import { FORMATO_MOMENTO_PIPE_2 } from 'src/app/compartido/utilidades/compartido.static';

@Component({
  selector: 'interior-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  /* Emisores */
  @Output() clickBotonSidenav: EventEmitter<undefined> = new EventEmitter<undefined>();

  /* Logo Organización */
  protected logoOrg: string | undefined;

  /* Usuario */
  protected usuario: UsuarioDTO | undefined;

  /* Constantes */
  protected readonly FORMATO_MOMENTO_PIPE_2 = FORMATO_MOMENTO_PIPE_2;

  constructor(
    protected readonly autenticacionService: AutenticacionService,
    protected readonly notificacionesService: NotificacionesService,
    private readonly _router: Router,
  ) {}

  ngOnInit(): void {
    this.autenticacionService.usuario$.then((usuario) => {
      if (!usuario) return;
      this.usuario = usuario;

      // Obtiene las notificaciones
      this.notificacionesService.actualizarNotificaciones$();
      this.notificacionesService.escucharWebSocket$(usuario);

      // Obtiene el logo de la organización para los clientes
      if (usuario.rol !== RolUsuario.CLIENTE || !usuario.cliente) return;
      this.logoOrg = usuario.cliente.organizacion.logo || undefined;
    });
  }

  /**
   * Realiza las acciones necesarias al hacer clic en una notificación.
   * @param {Notificacion} notificacion - La notificación a la que se le hizo clic.
   * @author Juan Corral
   */
  public clickNotificacion(notificacion: Notificacion): void {
    this.notificacionesService.marcarLeida$(notificacion);
    if (notificacion.url)
      this._router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this._router.navigate([notificacion.url]));
  }
}
